<template>
    <div class="explore_div">
        <!-- 使用multi-columns实现瀑布流 -->
        <div id="root">
            <router-link tag="a" :to="{ name: 'post', params: { id: post.number } }" v-for="post in posts" :key="post.id">
                <div class="item">
                    <img v-if="post.cover_url" class="itemImg"
                         :src="post.cover_url"
                         alt=""/>
                    <div class="userInfo">
                        <img class="avatar"
                             :src="post.author.avatar_url"
                             alt=""/>
                        <span class="username">{{post.title}}</span>
                    </div>
                    <div class="" v-if="post.content_description.length<=40" style="padding: 10px">
                        {{post.content_description}}
                    </div>
                    <div class="" v-else style="padding: 10px">
                        {{post.content_description.substring(0,40)}}......
                    </div>
                </div>
            </router-link>
        </div>
    </div>
</template>
<script type="text/javascript">
    import {mapState, mapActions} from 'vuex'
    import postApi from '@/api/post/post.js'

    export default {
        data() {
            return {
                'posts': []
            }
        },
        components: {},
        computed: {
            ...mapState({
                // sign_on: state => state.loginState.sign_on
            })
        },
        methods: {
            ...mapActions({
                // change_show_state: 'loginState/change_show_state',
            })
        },
        mounted() {
            // if (!this.sign_on) {
            //     this.change_show_state('on')
            // }
            postApi.get_explore_posts().then((response) => {
                this.posts = response.data
            })

        }
    }

</script>
<style type="text/css" scoped>
    body {
        background: #e5e5e5;
    }

    /* 瀑布流最外层 */
    #root {
        margin: 0 auto;
        width: 1200px;
        column-count: 5;
        column-width: 240px;
        column-gap: 20px;
    }

    /* 每一列图片包含层 */
    .item {
        margin-bottom: 10px;
        /* 防止多列布局，分页媒体和多区域上下文中的意外中断 */
        break-inside: avoid;
        background: #fff;
    }

    .item:hover {
        box-shadow: 2px 2px 2px rgba(0, 0, 0, .5);
    }

    /* 图片 */
    .itemImg {
        width: 100%;
        vertical-align: middle;
    }

    /* 图片下的信息包含层 */
    .userInfo {
        padding: 5px 10px;
    }

    .avatar {
        vertical-align: middle;
        width: 30px;
        height: 30px;
        border-radius: 50%;
    }

    .username {
        margin-left: 5px;
        text-shadow: 2px 2px 2px rgba(0, 0, 0, .3);
    }

</style>
